import { render, staticRenderFns } from "./RideitCommunicationsForm.vue?vue&type=template&id=4f974562&scoped=true"
import script from "./RideitCommunicationsForm.vue?vue&type=script&lang=ts"
export * from "./RideitCommunicationsForm.vue?vue&type=script&lang=ts"
import style0 from "./RideitCommunicationsForm.vue?vue&type=style&index=0&id=4f974562&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f974562",
  null
  
)

export default component.exports